import { useMemo, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import highlight from './highlight';

const LANG_LABEL = { cfg: 'kamailio.cfg', bash: 'shell', sip: 'SIP', sdp: 'SDP', ini: 'config', text: 'text' };

export default function CodeBlock({ lang = 'text', text, title }) {
  const [copied, setCopied] = useState(false);
  const lines = useMemo(() => highlight(lang, text), [lang, text]);

  const copy = () => {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    };
    try {
      navigator.clipboard.writeText(text).then(done, () => {});
    } catch (e) {
      /* clipboard unavailable */
    }
  };

  return (
    <figure className={`code code-${lang}`}>
      <figcaption className="code-head">
        <span className="code-dots" aria-hidden="true"><i /><i /><i /></span>
        <span className="code-title">{title || LANG_LABEL[lang] || lang}</span>
        <button type="button" className="code-copy" onClick={copy} aria-label="Copy code">
          {copied ? <Check size={15} /> : <Copy size={15} />}
          <span>{copied ? 'Copied' : 'Copy'}</span>
        </button>
      </figcaption>
      <pre>
        <code>
          {lines.map((tokens, i) => (
            <span className="code-line" key={i}>
              {tokens.map(([cls, t], j) => (cls ? <span key={j} className={`t-${cls}`}>{t}</span> : t))}
              {'\n'}
            </span>
          ))}
        </code>
      </pre>
    </figure>
  );
}
